import Timeline from './Timeline';

export type { TimelineProps } from './Timeline';
export type { TimelineItemProps } from './TimelineItem';

export default Timeline;
